<template>
  <div class="c-list-box">
    <ul class="c-list-nav">
      <li class="c-list-title">供应商档案</li>
      <el-button
        type="primary"
        :icon="Plus"
        link
        @click="
          delete state.selectId;
          state.showInfo = true;
        "
        v-if="$judge_auth('52')"
        >添加</el-button
      >
      <el-button type="primary" :icon="Upload" link @click="onExport">
        导出
      </el-button>
    </ul>
    <ul class="c-list-search">
      <el-input
        v-model="state.params.keywords"
        style="width: 200px"
        placeholder="名称、统一社会信用代码、联系人、联系电话"
        clearable
        @clear="
          delete state.params.keywords;
          onLoad();
        "
        @paste.enter="$onKeywordsPaste($event, state.params)"
      ></el-input>
      <el-radio-group v-model="state.params.status">
        <el-radio-button>全部</el-radio-button>
        <el-radio-button :value="1">正常</el-radio-button>
        <el-radio-button :value="0">停用</el-radio-button>
      </el-radio-group>
      <el-tree-select
        v-model="state.params.belonger_id"
        :props="{
          value: 'id',
          label: 'name',
          class: 'belonger-tree-class',
        }"
        placeholder="业务员"
        :data="state.admin_data"
        style="width: 200px"
        default-expand-all
        filterable
        clearable
      >
        <template #default="{ data }">
          <el-icon :size="16" v-if="data.type == 0"><UserFilled /></el-icon>
          <el-icon :size="16" v-else><User /></el-icon>
          <span style="margin-left: 3px">{{ data.name }}</span>
        </template>
      </el-tree-select>
      <el-dropdown split-button @click="onLoad" type="primary">
        查询
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
              重置
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </ul>
    <ul class="c-list-table">
      <el-table
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="序号"
          width="70"
          type="index"
          :index="
            (index) => (state.params.page - 1) * state.params.limit + index + 1
          "
          align="center"
        />
        <el-table-column
          label="状态"
          sortable="status"
          width="100"
          :formatter="
            (row) =>
              $statusFormat({
                Text: row.status == 1 ? '正常' : '停用',
                Color: row.status == 1 ? '#1e90ff' : '#f00',
              })
          "
        />
        <el-table-column prop="name" label="名称" :min-width="200">
          <template #default="{ row }">
            <text
              style="color: #1e90ff"
              class="text-hover-decoration"
              title="名称"
              @click="$onCopy(row.name)"
            >
              {{ row.name }}
            </text>
          </template>
        </el-table-column>
        <el-table-column
          label="所属地区"
          :formatter="
            (row) =>
              $tab_GroupFormat(
                row.province + (row.city || '') + (row.district || ''),
                row.address || ''
              )
          "
          min-width="220"
        />
        <el-table-column
          prop="unified_social_credit_identifier"
          label="统一社会信用代码"
          width="200"
        >
          <template #default="{ row }">
            <text
              style="color: #1e90ff"
              class="text-hover-decoration"
              title="统一社会信用代码"
              @click="$onCopy(row.unified_social_credit_identifier)"
            >
              {{ row.unified_social_credit_identifier }}
            </text>
          </template>
        </el-table-column>
        <el-table-column prop="contact_name" label="联系人" width="120" />
        <el-table-column prop="contact_phone" label="联系电话" width="160" />
        <el-table-column
          prop="belonger_id"
          label="业务员"
          min-width="160"
          :formatter="
            (row) =>
              $tab_GroupFormat(
                row.belonger_name,
                row.belonger_department_name || ''
              )
          "
        />
        <el-table-column
          label="操作"
          width="160"
          align="center"
          fixed="right"
          className="tabBtn"
        >
          <template #default="{ row }">
            <el-button
              type="primary"
              link
              icon="Edit"
              @click="
                $store.commit('openMenu', {
                  path: 'SupplierDetail',
                  title: row.name,
                  refresh: true,
                  data: {
                    id: row.id,
                  },
                })
              "
              v-if="$judge_auth('53')"
            >
              管理
            </el-button>
            <el-button
              type="primary"
              link
              icon="Views"
              @click="
                $store.commit('openMenu', {
                  path: 'SupplierDetail',
                  title: row.name,
                  refresh: true,
                  data: {
                    id: row.id,
                  },
                })
              "
              v-else
            >
              查看
            </el-button>
            <el-button
              type="danger"
              link
              icon="Delete"
              @click="onDelete(row.id)"
              v-if="$judge_auth('54')"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </ul>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showInfo"
        :title="(state.selectId ? '修改' : '添加') + '供应商'"
        @close="state.showInfo = false"
      >
        <c_SupplierInfo
          @close="
            state.showInfo = false;
            onLoad();
          "
          :id="state.selectId"
        ></c_SupplierInfo>
      </c_popup>
    </transition>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showBelonger"
        title="选择负责人"
        @close="state.showBelonger = false"
      >
        <c_AdminSelect
          @submit="
            (item) => {
              state.params.belonger_id = item.id;
              state.params.belonger = item.name + '/' + item.department_name;
              state.showBelonger = false;
            }
          "
          :id="state.model.belonger_id"
        ></c_AdminSelect>
      </c_popup>
    </transition>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { admin_cascader } from "@/utils/qFormat";
import {
  supplier_list,
  supplier_delete,
  supplier_export,
} from "@/http/supplier";
import { confirm_func } from "@/utils/qFormat";
import { ElMessage } from "element-plus";

class InitFormData {
  params = {
    limit: 20,
    page: 1,
    sort_field: "create_time",
    sort_value: "desc",
    name: "",
  };
}
export default {
  setup() {
    const state = reactive(new InitFormData());
    onMounted(() => {
      onLoadAdmin();
      onLoad();
    });

    //加载业务员
    const onLoadAdmin = () => {
      admin_cascader().then((res) => {
        state.admin_data = res;
      });
    };

    const onLoad = () => {
      delete state.tableData;

      supplier_list(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;

          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      Object.assign(state, new InitFormData());
      onLoad();
    };

    //删除
    const onDelete = (id) => {
      confirm_func(supplier_delete, id, onLoad);
    };

    const onExport = () => {
      let params = JSON.parse(JSON.stringify(state.params));
      params.limit = 0;
      supplier_export(params)
        .then((res) => {
          let fileName = decodeURI(
            res.headers["content-disposition"].split("=")[1]
          );

          //通过后台返回 的word文件流设置文件名并下载
          var blob = new Blob([res.data], {
            type: res.data.type,
          });
          var downloadElement = document.createElement("a");
          var href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = fileName; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
        })
        .catch((err) => {
          const fileReader = new FileReader();
          fileReader.readAsText(
            new Blob([err.data], { type: "application/octet-stream" }),
            "utf-8"
          );
          fileReader.onload = () => {
            const msg = JSON.parse(fileReader.result);
            ElMessage.error(msg?.msg);
          };
        });
    };

    return {
      state,
      onLoad,
      onSortChange,
      onReset,
      onDelete,
      onLoadAdmin,
      onExport,
    };
  },
};
</script>
<style scoped></style>
